<template>
    <div>
        <div class="label-text small-light">
            {{ label }}
        </div>
        <div class="label-input body-light">
            {{ getText(value) }}
        </div>
    </div>
</template>

<script>
export default {
    name: "LabelInput",
    props: {
        label: {
            type: String,
            default: ''
        },
        value: {
            type: [Number, String],
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        }
    },
    methods: {
        getText(value) {
            const vm = this
            if(value === 'n/d') return value
            switch (vm.type) {
                case 'boolean':
                    return value ? 'Si' : 'No'
                case 'money':
                    return `$${vm.$options.filters.number(value) || 0}`
                case 'rut':
                    return `${vm.$options.filters.rutificador(value)}`
                case 'discount':
                    return `-${value}%`
                case 'phone':
                    return `${vm.phoneCode}${value}`
                default:
                    return value
            }
        }
    }
}
</script>

<style scoped>

.label-text {
    color: #939BB3;
    margin-bottom: 4px;
}

.label-input {
    background: #FFFFFF;
    border: 1px solid #C9CDD9;
    box-sizing: border-box;
    border-radius: 8px;
    color: #273866;
    padding: 4px 20px;
}

</style>